import { Language } from '../../../../Models/Enums/Language';
import { StoreState } from '../../Global/StoreState';

export function preferredLanguage(state: StoreState): Language {
  return state.preferences.language;
}
